'use strict';

angular.module('imagetrend.components')
    .controller('PhotoUploadModalController', ['$scope', '$uibModalInstance', 'Upload', 'file_content', function ($scope, $uibModalInstance, Upload, file_content) {

        $scope.file_content = file_content;
        $scope.uploading = false;

        $scope.resizeOptions = function () {
            return {
                quality: 1.0,
                width: 440,
                height: 440
            }
        }

        $scope.resizeConditions = function (file, width, height) {
            return width > 220 || height > 100;
        }

        $scope.fileUpdated = function (file) {
            Upload.base64DataUrl(file).then(function (content) {
                $scope.file_content = content;
                $scope.uploading = false;
            });
        }

        $scope.filePicked = function () {
            $scope.uploading = true;
        }

        $scope.save = function (file, file_content) {
            if (file != null) {
                $uibModalInstance.close({
                    file_name: file.name,
                    file_content: file_content
                });
            }
            else {
                $uibModalInstance.dismiss('cancel');
            }
        }

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }])
;